export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 140,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('form_label_hxFtyInboundNo') || '入库单号',
    field: 'hxFtyInboundNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: that.$l('form_label_hxPurchaseNo') || '采购单编号',
  //   field: 'hxPurchaseNo',
  //   width: 150,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  {
    title: that.$l('form_label_inboundDate') || '入库日期',
    field: 'inboundDate',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_scm') || '工厂',
    field: 'scmName',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_ecomWarehouse') || '入库仓库',
    field: 'ecomWarehouseName',
    minWidth: 250,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_buyer') || '采购人员',
    field: 'buyerName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_totalQty') || '总入库数量',
    field: 'totalQty',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('form_label_totalAmount') || '总入库金额',
    field: 'totalAmount',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { totalAmount: value, v_currencyUnit: unit } = row
      return [that.format(value) || 0, unit].filter(Boolean).join(' ')
    },
  },
  {
    title: that.$l('table_label_totalCtnQty') || '总箱数',
    field: 'totalCtnQty',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalGrossWeight') || '入库总毛重(KGS)',
    field: 'totalGrossWeight',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalCbm') || '入库总体积(CBM)',
    field: 'totalCbm',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },

  {
    title: that.$l('INDEX.Status') || '有效状态',
    field: 'hxFtyInboundStatus',
    width: 80,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createDate',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyDate',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
